var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-export"},[_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.clickExport}},[_vm._v("导出Excel")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }